import React from "react";
import "./ProjectCard.css";
import { useNavigate } from "react-router-dom";

const ProjectCard = ({ id, image, title, desc, tech }) => {
  const navigate = useNavigate();

  const handleDetailClick = () => {
    navigate(`/project/${id}`);
  };

  return (
    <div className="project-card">
      <div className="top-cont">
        <img src={image} alt={title} className="project-image" />
        <div className="inner-cont">
          <h3 className="project-title">{title}</h3>
          <div className="kullanilanTeknolojilerCard">
            {tech.map((tech, index) => (
              <span key={index} className="teknoloji-badgeCard">{tech}</span>
            ))}
          </div>
        </div>
      </div>
      <p className="project-desc">{desc}</p>
      <button className="detail-button" onClick={handleDetailClick}>
        Proje Detayı
      </button>
    </div>
  );
};

export default ProjectCard;
